export const INSTRUCTION = {
  CREATED_BY: 'createdBy',
  TEXT: 'text',
  READ_BY: 'readBy',
  LAWYER_CODE: 'lawyerCode',
  CREATED_AT: 'createdAt',
};
